import { forwardRef } from "react";
import ReactToPrint from "react-to-print";
import { Printer } from "../../AllSvg";
import {
    DownloadBulkDocumentsAsZip,
} from "../../CustomFunctions";


const TemplateDisplayWrapper = forwardRef(
    ({ onBack, empCode, empname, expenseDataDetails, downloadEnable = false }, ref) => {

        const printButton = (
            <ReactToPrint
                bodyClass="print-agreement"
                content={() => ref.current}
                trigger={() => (
                    <button
                        className="model-button model-button-black"
                    >
                        <Printer /> Print
                    </button>
                )}
            />
        );



        return (
            <div
                className="flex-column flex-center hide-on-print"
                style={{
                    minHeight: "fit-content",
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                    backgroundColor: "rgb(251 251 251)",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                }}
            >
                <div
                    className="printSlip-width"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    {onBack && (
                        <button
                            className="model-button font-weight500 model-button-cancel font-size-heading"
                            onClick={onBack}
                        >
                            ← Back
                        </button>
                    )}
                    {/* {printButton} */}
                    {downloadEnable && (
                        <DownloadBulkDocumentsAsZip
                            id="DownloadFilesZip"
                            emp_code={empCode}
                            emp_name={empname}
                            document_list={expenseDataDetails}
                            doc_name_key={"item_name"}
                            doc_file_key={"bill"}
                        />
                    )}

                </div>
            </div>
        );
    }
);

export default TemplateDisplayWrapper;


